<template>
  <div v-show="show">
    <FormKit
      :class="{ 'formulate-input--horizontal-layout': field.layout === 'horizontal', 'formulate-input--vertical-layout': field.layout === 'vertical' }"
      :help-position="helpPosition"
      :help="field.instructions"
      :label="field.name"
      :name="name"
      :options="options"
      :validation="validation"
      :value="value"
      type="checkbox"
    />
  </div>
</template>

<script setup lang="ts">
import { fieldDefaultOptions, fieldHelpPosition, fieldName, fieldOptions, fieldValidationArray, fieldVisible } from '~/assets/formie'

interface Props {
  settings: object
  parentField?: object
  field: object
}

const props = defineProps<Props>()

const helpPosition = fieldHelpPosition(props.settings, props.field)
const name = fieldName(props.field, props.parentField)
const options = fieldOptions(props.field)
const show = fieldVisible(props.field)
const validation = fieldValidationArray(props.field)
const value = fieldDefaultOptions(props.field)
</script>
